import {
    Button,
    Form,
    Select,
    Modal,
    Typography,
    Space,
    Popconfirm,
} from "antd";
import {
    CodeOutlined,
    DeleteOutlined,
    EditOutlined,
    EyeOutlined,
} from "@ant-design/icons";

import { getFileURL, getImageFileURL } from "../_helpers/image";
import styles from "./styles/SingleTemplateItem.module.css";
import React, { useState } from "react";
import {
    useUpdateItemMutation,
    useDeleteItemMutation,
    useCreateItemMutation,
} from "../actions/app/items";
import LinkCreationModal from "./LinkCreationModal";
import RelationFieldStanard from "../qforms/standard_elements/RelationFieldStandard";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { CREATOR_BASE_URL } from "../constants";
import { useStartTyping } from "react-use";
import log from "cslog";

function SingleTemplateItem({
    data,
    previewTemplate,
    editTemplate,
    show_primary_tag = false,
    onDelete,
}) {
    const [presetModalOpen, setPresetModalOpen] = useState(false);
    const mutationUpdate = useUpdateItemMutation(() => {
        // success
    });
    const mutationDelete = useDeleteItemMutation(() => {
        // success callback - call onDelete if provided
        if (onDelete) {
            onDelete(data.id);
        }
    });
    const mutationCreate = useCreateItemMutation(() => {
        // success
    });

    const handleDeleteTemplate = () => {
        mutationDelete.mutate({
            collection: "qdb_creation_template",
            id: data.id,
        });
    };
    return (
        <div className={styles.wrapper}>
            <div className={styles.left_box}>
                <img
                    alt="preview"
                    src={getImageFileURL(data.preview?.filename_disk)}
                    className={styles.preview}
                />
            </div>
            <div className={styles.right_box}>
                <div>
                    <h4 className={styles.title}>{data.title}</h4>
                    <div className={styles.tags_wrapper}>
                        {data.tags?.map((tag) => (
                            <div className={styles.tag}>
                                {tag.qdb_tag_id.name}
                            </div>
                        ))}
                    </div>
                    <Button
                        style={{ margin: "10px 0" }}
                        icon={<EyeOutlined />}
                        onClick={() => previewTemplate()}
                    ></Button>
                    <Button
                        style={{ margin: "10px 10px" }}
                        icon={<EditOutlined />}
                        onClick={() =>
                            window.open(
                                `${CREATOR_BASE_URL}template/${data.id}`,
                                "_blank"
                            )
                        }
                        // onClick={() =>
                        //     window.open(
                        //         `https://api.qureal.com/admin/content/qdb_creation_template/${data.id}`,
                        //         "_blank"
                        //     )
                        // }
                    ></Button>
                    <Button
                        danger
                        icon={<DeleteOutlined />}
                        loading={mutationDelete.isLoading}
                        onClick={handleDeleteTemplate}
                        style={{ margin: "10px 0" }}
                    ></Button>
                </div>

                <div className={styles.tags_wrapper}>
                    {/* <Button type="primary" onClick={editTemplate}>Auto add tags</Button> */}
                    {data.status === "draft" && (
                        <Button
                            type="primary"
                            loading={mutationUpdate.isLoading}
                            onClick={() => {
                                mutationUpdate.mutate({
                                    collection: "qdb_creation_template",
                                    id: data?.id,
                                    data: {
                                        status: "published",
                                    },
                                });
                            }}
                        >
                            Publish
                        </Button>
                    )}
                    {data.status === "published" && (
                        <Button
                            type="primary"
                            loading={mutationUpdate.isLoading}
                            onClick={() => {
                                mutationUpdate.mutate({
                                    collection: "qdb_creation_template",
                                    id: data?.id,
                                    data: {
                                        status: "draft",
                                    },
                                });
                            }}
                        >
                            Unpublish
                        </Button>
                    )}
                    <Button
                        type="primary"
                        icon={<CodeOutlined />}
                        onClick={() =>
                            window.open(
                                `https://api.qureal.com/admin/content/qdb_creation_template/${data.id}`,
                                "_blank"
                            )
                        }
                    >
                        Edit Code
                    </Button>

                    {data.used_schemas != null && (
                        <Button
                            type="primary"
                            onClick={() => setPresetModalOpen(true)}
                        >
                            Preset
                        </Button>
                    )}

                    {/* {data.creation === null && <Button style={{ backgroundColor: "#f5cb42" }}>Link Creation</Button>} */}
                    {data.creation === null && (
                        <LinkCreationModal
                            data={data}
                            trigger={
                                <Button style={{ backgroundColor: "#f5cb42" }}>
                                    Link Creation
                                </Button>
                            }
                        />
                    )}

                    <Select
                        value={data.branding_type}
                        onChange={(new_val) => {
                            mutationUpdate.mutate({
                                collection: "qdb_creation_template",
                                id: data?.id,
                                data: {
                                    branding_type: new_val,
                                },
                            });
                        }}
                        loading={mutationUpdate.isLoading}
                        style={{ width: "200px" }}
                        options={[
                            { label: "None", value: "none" },
                            {
                                label: "Organization Minimal",
                                value: "org_minimal",
                            },
                            {
                                label: "Organization Detailed",
                                value: "org_detailed",
                            },
                            {
                                label: "Personal Minimal",
                                value: "personal_minimal",
                            },
                            {
                                label: "Personal Detailed",
                                value: "personal_detailed",
                            },
                        ]}
                    />

                    {show_primary_tag && (
                        <RelationFieldStanard
                            field={{
                                foreign_key_table: "qdb_tag",
                                foreign_key_column: "id",
                                junction_field: "qdb_tag_id",
                                many_table_pk: "id",
                                template: "{{name}}",
                                type: "relationO2M",
                            }}
                            fieldString="filter[type][_eq]=primary&limit=-1"
                            key={data?.id}
                            value={data?.primary_tags?.[0]?.qdb_tag_id}
                            onChange={(val) => {
                                mutationUpdate.mutate({
                                    collection: "qdb_creation_template",
                                    id: data?.id,
                                    data: {
                                        primary_tags: [{ qdb_tag_id: val }],
                                    },
                                });
                            }}
                            many={false}
                            style={{
                                width: "90%",
                            }}
                            additional_options={[]}
                        />
                    )}
                </div>
            </div>
            <PresetModal
                open={presetModalOpen}
                setOpen={setPresetModalOpen}
                usedSchemas={data.used_schemas}
                templateId={data.id}
                mutationdelete={mutationDelete}
                mutationcreate={mutationCreate}
            />
        </div>
    );
}

export default SingleTemplateItem;

function PresetModal({
    open,
    setOpen,
    usedSchemas,
    templateId,
    mutationdelete,
    mutationcreate,
}) {
    const [selectedSchema, setSelectedSchema] = useState(null);
    const alreadyUsed =
        !!selectedSchema &&
        Array.isArray(usedSchemas) &&
        usedSchemas.some(
            (s) =>
                s?.qdb_creation_schema_id?.id === selectedSchema ||
                s?.qdb_creation_schema_id === selectedSchema
        );

    const handleDeleteSchema = (schemaId) => {
        // Filter out the schema to be deleted

        log.d(schemaId, "delete preset");
        mutationdelete.mutate({
            collection: "qdb_creation_template_qdb_creation_schema",
            id: schemaId,
        });
    };
    const handleAddSchema = () => {
        if (!selectedSchema || alreadyUsed) return;
        mutationcreate.mutate({
            collection: "qdb_creation_template_qdb_creation_schema",
            data: {
                qdb_creation_template_id: templateId,
                qdb_creation_schema_id: selectedSchema,
            },
        });
        // Optimistically clear selection
        setSelectedSchema(null);
    };
    console.log("used schemas", usedSchemas);
    return (
        <Modal
            open={open}
            onCancel={() => setOpen(false)}
            title="Template Presets"
            width={800}
            footer={[
                <Button key="close" onClick={() => setOpen(false)}>
                    Close
                </Button>,
            ]}
        >
            <div>
                <Space
                    direction="vertical"
                    style={{ width: "100%", marginBottom: 12 }}
                    size="small"
                >
                    <Typography.Title level={5} style={{ margin: 0 }}>
                        Add Preset
                    </Typography.Title>
                    <Space align="start" style={{ width: "100%" }}>
                        <div style={{ flex: 1 }}>
                            <RelationFieldStanard
                                field={{
                                    foreign_key_table: "qdb_creation_schema",
                                    foreign_key_column: "id",
                                    junction_field: "id",
                                    many_table_pk: "id",
                                    template: "{{name}}",
                                    type: "relationO2M",
                                }}
                                // Adjust filters if needed
                                fieldString="limit=-1&sort=name&filter[block_id][_eq]=heading_preset"
                                value={selectedSchema}
                                onChange={(val) => setSelectedSchema(val)}
                                many={false}
                                style={{ width: "200px" }}
                                additional_options={[]}
                            />
                        </div>
                        <Button
                            type="primary"
                            disabled={!selectedSchema || alreadyUsed}
                            loading={mutationcreate?.isLoading}
                            onClick={handleAddSchema}
                        >
                            Add
                        </Button>
                    </Space>
                    {alreadyUsed && (
                        <Typography.Text type="secondary">
                            This schema is already added to the template.
                        </Typography.Text>
                    )}
                </Space>

                {usedSchemas && usedSchemas.length > 0 ? (
                    <Space
                        direction="vertical"
                        style={{ width: "100%" }}
                        size="middle"
                    >
                        {usedSchemas.map((schema, index) => (
                            <div
                                key={schema.id || index}
                                style={{
                                    border: "1px solid #d9d9d9",
                                    borderRadius: "6px",
                                    padding: "8px",
                                    backgroundColor: "#fafafa",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "flex-start",
                                }}
                            >
                                <div style={{ flex: 1 }}>
                                    <Typography.Title
                                        level={5}
                                        style={{
                                            margin: 0,
                                            marginBottom: "8px",
                                        }}
                                    >
                                        {schema.qdb_creation_schema_id?.name ||
                                            `Schema ${index + 1}`}
                                    </Typography.Title>
                                </div>

                                <Button
                                    type="text"
                                    danger
                                    icon={<DeleteOutlined />}
                                    loading={mutationdelete.isLoading}
                                    onClick={() =>
                                        handleDeleteSchema(schema.id)
                                    }
                                />
                            </div>
                        ))}
                    </Space>
                ) : (
                    <div style={{ textAlign: "center", padding: "40px" }}>
                        <Typography.Text type="secondary">
                            No schemas found for this template
                        </Typography.Text>
                    </div>
                )}
            </div>
        </Modal>
    );
}
